import React, { useState, useEffect } from "react";
import { Container, Table, Image, Modal, Button } from 'react-bootstrap';
import Switch from '@mui/material/Switch';
import { Link } from 'react-router-dom';
import { useAuth } from "../../context/AuthContext";
import axios from "axios";
import enviarCorreo from "../../firebase/enviarCorreo";



const AutoexcluidosDetalle = ({ autoexcluidoData, showModal, modalImageSrc, handleModalShow, handleModalClose }) => {
  const formatFechaHora = (marcaDeTiempo) => {
    const fecha = new Date(marcaDeTiempo);
    const opciones = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      timeZone: 'UTC', // Establecer la zona horaria a UTC
    };
    return new Intl.DateTimeFormat('es-AR', opciones).format(fecha);
  };

  const renderValorAnterior = (valorAnterior) => {
    if (typeof valorAnterior === 'boolean') {
      return valorAnterior ? 'Sí' : 'No';
    } else if (typeof valorAnterior === 'string') {
      if (/^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/.test(valorAnterior)) {
        return (
          <span
            className="link"
            onClick={() => handleModalShow(valorAnterior)}
          >
            Ver valor anterior
          </span>
        );
      } else {
        return <span>{valorAnterior}</span>;
      }
    } else {
      return <span>{valorAnterior}</span>;
    }
  };
  const [registroExitoso, setRegistroExitoso] = useState(false);
  const [loading, setLoading] = useState(false);


  const auth = useAuth();
  const registerChange = async (tipo) => {
    try {
      setLoading(true);
      // Verifica que haya un usuario autenticado y autoexcluidoData no sea null
      if (auth.user && autoexcluidoData && autoexcluidoData.id) {
        const cambio = {
          tipo,
          marcaDeTiempo: new Date().toISOString(),
          usuario: auth.user,
        };

        // Crea una copia del array actual de cambios y agrega el nuevo cambio
        const cambios = [...autoexcluidoData.cambios, cambio];

        // Envia el cambio al servidor y actualiza el estado local después del éxito
        await axios.post(`https://us-central1-inprojuy-f1173.cloudfunctions.net/app/modiautoexcluidos/${autoexcluidoData.id}`, {
          cambios: cambios,
          // Resto de los datos que necesitas enviar
        });

        // Actualiza el estado local después del éxito del servidor
        //setAutoexcluidoData((prevData) => ({
        //  ...prevData,
        //  cambios: cambios,
        //}));

        // Indica que el registro fue exitoso

        const hoy = new Date();
        const texto = `
        <h3 style="text-align: justify;">Sr Operador:<br /><br /><br />Le informamos que el día ${formatFechaHora(hoy).split(',')[0]}, el SRA./SR ${autoexcluidoData.nombre} , DNI ${autoexcluidoData.dni}, Auto excluido Asistió a una sala de juego  con la finalidad de ingresar a jugar.
        Por lo que se les da aviso para que tomen los recaudos necesarios.</h3>
        <h3>Sin otro particular saludo a Usted, muy atentamente.</h3>
        `;

        fetch('https://us-central1-inprojuy-f1173.cloudfunctions.net/app/automails')
          .then(response => response.json())
          .then(data => {
            // Obtener la lista de correos
            const listaCorreos = data.map(item => item.email);
            console.log(listaCorreos);

            // Enviar correo a cada correo de la lista         enviarCorreo('comunicacion@inprojuy.gob.ar',asunto,texto).then(res=>{alert("mail enviado")
            listaCorreos.forEach(correo => {
              //alert('Enviando correo a: '+ correo);
              enviarCorreo(correo, 'Intento de Ingreso', texto)
                .then(res => {
                  console.log('Correo enviado correctamente:', res);

                })
                .catch(error => {
                  console.error('Error al enviar correo:', error);
                  alert("Error al enviar correo a: " + correo);
                });
            });




          })
          .catch(error => console.error('Error:', error));

        setRegistroExitoso(true);

      }
    } catch (error) {
      console.error("Error registrando intento", error);
    }
    finally {

      alert("Correo enviado correctamente");
      setLoading(false); // Desbloquea el botón y oculta la ruedita de carga

    }
  };


  const renderValorActual = (valorActual) => {
    if (typeof valorActual === 'boolean') {
      return valorActual ? 'Sí' : 'No';
    } else if (typeof valorActual === 'string') {
      if (/^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/.test(valorActual)) {
        return (
          <span
            className="link"
            onClick={() => handleModalShow(valorActual)}
          >
            Ver valor actual
          </span>
        );
      } else {
        return <span>{valorActual}</span>;
      }
    } else {
      return <span>{valorActual}</span>;
    }
  };

  return (
    <div className="container-fluid py-4 fondotransparente5" style={{ minHeight: '100vh', paddingBottom: 80 }}>
      <Container style={{ height: '100%', width: '100%', maxWidth: 600, padding: 0 }}>
        <div style={{ height: '100%', width: '100%' }}>
          <div style={{ textAlign: 'center', marginBottom: 12 }}>
            <h2 className="botonbordeazul text-white px-3 py-2 mb-3" style={{ fontSize: 22, borderRadius: 10 }}>Detalle del Autoexcluido</h2>
          </div>
          {autoexcluidoData && (
            <>
              <hr style={{ margin: '10px 0' }} />
              <div style={{ textAlign: 'center', marginBottom: 16 }}>
                <Image
                  src={autoexcluidoData.fotos.filter((foto) => foto !== null).pop() || ''}
                  alt={`Foto de ${autoexcluidoData.nombre}`}
                  fluid
                  style={{
                    width: 'min(80vw, 260px)',
                    height: 'min(80vw, 260px)',
                    maxWidth: 260,
                    maxHeight: 260,
                    objectFit: 'cover',
                    borderRadius: 14,
                    boxShadow: '0 2px 12px rgba(0,0,0,0.10)'
                  }}
                  onClick={() =>
                    handleModalShow(
                      autoexcluidoData.fotos.filter((foto) => foto !== null).pop() || ''
                    )
                  }
                />
              </div>
              <ul style={{
                fontSize: '1.08em',
                padding: 0,
                listStyle: 'none',
                margin: 0,
                maxWidth: 420,
                marginLeft: 'auto',
                marginRight: 'auto',
                lineHeight: 1.35
              }}>
                <li><strong>Nombre:</strong> {autoexcluidoData.nombre}</li>
                <li><strong>DNI:</strong> {autoexcluidoData.dni}</li>
                <li><strong>Email:</strong> {autoexcluidoData.mail}</li>
                <li><strong>Domicilio:</strong> {autoexcluidoData.domicilio}</li>
                <li><strong>Nacionalidad:</strong> {autoexcluidoData.nacionalidad}</li>
                <li><strong>Teléfono:</strong> {autoexcluidoData.telefono}</li>
                <li><strong>Teléfono de Apoyo:</strong> {autoexcluidoData.telefonoApoyo}</li>
                <li><strong>Ocupación:</strong> {autoexcluidoData.ocupacion}</li>
                <li><strong>Localidad:</strong> {autoexcluidoData.localidad}</li>
                <li><strong>Fecha de Nacimiento:</strong> {autoexcluidoData.fechaNacimiento}</li>
                <li><strong>Activo:</strong> <Switch checked={autoexcluidoData.activo} /></li>
                <li><strong>Fecha de Alta:</strong> {autoexcluidoData.alta.split('T')[0]}</li>
                <li><strong>Fecha de Vencimiento:</strong> {autoexcluidoData.vencimiento.split('T')[0]}</li>
                <li><strong>Lugar de Entrega:</strong> {autoexcluidoData.lugarEntrega}</li>
              </ul>

              {autoexcluidoData.pdfDocument && autoexcluidoData.pdfDocument.length > 0 && (
                <>
                  <h3>Documentos Adjuntos:</h3>
                  <Table striped bordered hover>
                    <thead>
                      <tr>
                        <th>Documento</th>
                        <th>Pdf</th>
                      </tr>
                    </thead>
                    <tbody>
                      {autoexcluidoData.pdfDocument.map((documento, index) => (
                        <tr key={index}>
                          <td>{documento.nombredoc}</td>
                          <td>
                            <a href={documento.url} target="_blank" rel="noopener noreferrer">
                              Ver PDF
                            </a>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </>
              )}

              {autoexcluidoData.observaciones && autoexcluidoData.observaciones.length > 0 && (
                <>
                  <h3>Observaciones:</h3>
                  <Table striped bordered hover>
                    <thead>
                      <tr>
                        <th>Fecha</th>
                        <th>Observación</th>
                      </tr>
                    </thead>
                    <tbody>
                      {autoexcluidoData.observaciones.map((observacion, index) => (
                        <tr key={index}>
                          <td>{(observacion.fecha.split('T')[0])}</td>
                          <td>{observacion.observacion}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </>
              )}

              {autoexcluidoData.cambios && autoexcluidoData.cambios.length > 0 && (
                <>
                  <h3>Historial de Cambios:</h3>
                  <Table striped bordered hover>
                    <thead>
                      <tr>
                        <th>Tipo de Cambio</th>
                        <th>Fecha y Hora</th>
                        <th>Usuario</th>
                        <th>Valor Anterior</th>
                        <th>Valor Actual</th>
                      </tr>
                    </thead>
                    <tbody>
                      {autoexcluidoData.cambios.map((cambio, index) => (
                        <tr key={index}>
                          <td>{cambio.tipo}</td>
                          <td>{formatFechaHora(cambio.marcaDeTiempo)}</td>
                          <td>{cambio.usuario}</td>
                          <td>{renderValorAnterior(cambio.valorAnterior)}</td>
                          <td>{renderValorActual(cambio.valorActual)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </>
              )}

              <div style={{ display: 'flex', flexDirection: 'column', gap: 10, margin: '18px 0 8px 0', alignItems: 'center' }}>
                <Link to={`/ModificarAutoexcluido/${autoexcluidoData.dni}`}
                  style={{
                    background: '#fff',
                    color: '#1976d2',
                    border: '2px solid #1976d2',
                    borderRadius: 8,
                    fontWeight: 600,
                    fontSize: 16,
                    padding: '7px 28px',
                    textDecoration: 'none',
                    boxShadow: '0 1px 6px rgba(25,118,210,0.07)'
                  }}
                >Editar</Link>
                <button
                  onClick={() => registerChange("Asistencia a lugar de juego")}
                  disabled={loading}
                  style={{
                    background: '#1976d2',
                    color: '#fff',
                    border: 'none',
                    borderRadius: 8,
                    fontSize: 16,
                    padding: '10px 18px',
                    fontWeight: 600,
                    width: '100%',
                    maxWidth: 320,
                    boxShadow: '0 2px 8px rgba(25,118,210,0.08)'
                  }}
                >
                  {loading ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> : "Registrar Asistencia a Agencia o Sala de Juego"}
                </button>
              </div>



            </>
          )}
        </div>
      </Container>

      <Modal show={showModal} onHide={handleModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Imagen</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Image src={modalImageSrc} alt="Imagen" fluid />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleModalClose}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Botón cerrar fijo abajo para mobile */}
      <div style={{
        position: 'fixed',
        left: 0,
        bottom: 0,
        width: '100vw',
        background: 'rgba(255,255,255,0.97)',
        borderTop: '1.5px solid #e0e0e0',
        zIndex: 9999,
        padding: '12px 0 10px 0',
        display: 'flex',
        justifyContent: 'center',
        boxShadow: '0 -2px 12px rgba(0,0,0,0.07)'
      }}>
        <Button
          variant="primary"
          onClick={handleModalClose}
          style={{
            background: '#1976d2',
            border: 'none',
            borderRadius: 8,
            fontSize: 18,
            fontWeight: 600,
            padding: '10px 38px',
            boxShadow: '0 2px 8px rgba(25,118,210,0.10)'
          }}
        >
          Cerrar
        </Button>
      </div>
    </div>
  );
};

export default AutoexcluidosDetalle;
